import { MasterInfoEnum, ROUTERS } from '@/constant';
import { memo } from 'react';

import Button from '../common/button';
import FilterWithViewAll from '../common/filter-with-view-all';
import Modal from '../common/modal';
import Table from '../common/table';
import { ColumnTypes } from '../common/table/type';
import { rowKey } from './select-applicant-modal.config';
import { useLogic } from './select-applicant-modal.logic';
import { IProps } from './select-applicant-modal.type';

const SelectApplicantModal = (props: IProps) => {
	const {
		open,
		onCloseModal,
		title = '근로자 선택',
		program,
		subTitle = '고용주',
		description,
		...rest
	} = props;

	const {
		filterRef,
		initialValues,
		fetchData,
		columns,
		dataSource,
		rowSelection,
		onSaveClick,
		searchFilterRef,
		fetching,
	} = useLogic(props);

	return (
		<Modal open={open} onCancel={onCloseModal} title={title} {...rest}>
			<p className="text-[14px] font-bold mb-[5px]">{subTitle}</p>
			<p className="text-[15px] font-medium text-font2 mb-10">
				{description ?? program?.name}
			</p>

			<p className="text-[14px] font-bold mb-[5px]">근로자 선택</p>
			<div className="mb-5 flex ">
				<FilterWithViewAll
					ref={filterRef}
					initialValues={initialValues}
					rowSelection={rowSelection}
					fetchData={fetchData}
					inputName="applicantName"
					inputPlaceholder="성/이름"
					inputClassName="w-[376px]"
					buttonClassName="w-[60px] min-w-0"
					hidePageSize
					isShowAutoComplete
					autoCompleteProps={{
						type: MasterInfoEnum.AUTOCOMPLETE_APPLICANT_NAME,
					}}
				/>
			</div>

			<Table
				columns={columns as ColumnTypes}
				dataSource={dataSource}
				rowSelection={{ ...rowSelection }}
				rowKey={rowKey}
				pagination={false}
				editable
				toDetailPathName={ROUTERS.AR1_03}
				searchFilterRef={searchFilterRef}
				scroll={{ y: 400 }}
				loading={fetching}
			/>

			<Button
				type="primary"
				className="mt-10 mx-auto block"
				onClick={onSaveClick}
				isMainBtn
			>
				저장
			</Button>
		</Modal>
	);
};

export default memo(SelectApplicantModal);
